import React, { useState } from 'react';

const TAX_INFO = [
    {
        id: 'sales',
        title: 'Sales Tax',
        description: 'New Jersey has a statewide sales tax rate of 6.625% on most purchases. Some items are exempt from sales tax, including most grocery food items, clothing, and prescription medications.',
        details: [
            'Rate: 6.625% statewide',
            'No local sales taxes are imposed in NJ',
            'Certain urban enterprise zones charge 3.3125%',
            'Exempt items include unprepared food, prescription drugs, clothing'
        ]
    },
    {
        id: 'income',
        title: 'Income Tax',
        description: 'New Jersey has a progressive income tax system with rates ranging from 1.4% to 10.75% depending on income level and filing status.',
        details: [
            '1.4% on income up to $20,000',
            '1.75% on income between $20,001 and $35,000',
            '3.5% on income between $35,001 and $40,000',
            '5.525% on income between $40,001 and $75,000',
            '6.37% on income between $75,001 and $500,000',
            '8.97% on income between $500,001 and $1,000,000',
            '10.75% on income over $1,000,000'
        ]
    },
    {
        id: 'property',
        title: 'Property Tax',
        description: 'New Jersey has some of the highest property taxes in the nation. The average effective property tax rate is around 2.42% of a property\'s assessed value, but rates vary significantly by county and municipality.',
        details: [
            'Rates vary by county and municipality',
            'The average effective property tax rate is approximately 2.42%',
            'Senior Freeze program available for qualifying seniors',
            'Property tax deductions available for veterans, seniors, and disabled persons'
        ]
    },
    {
        id: 'other',
        title: 'Other Taxes',
        description: 'New Jersey imposes various other taxes including gas tax, cigarette tax, alcohol tax, and more.',
        details: [
            'Gas Tax: 50.7 cents per gallon (as of 2024)',
            'Cigarette Tax: $2.70 per pack of 20',
            'Real Estate Transfer Tax: Generally 1% of sale price',
            'Hotel/Motel Occupancy Fee: 5% statewide',
            'Inheritance Tax: Ranges from 0% to 16% based on beneficiary class',
            'Mansion Tax: 1% on property sales over $1 million'
        ]
    }
];

function TaxInfoPanel() {
    const [activeInfo, setActiveInfo] = useState('sales');

    return (
        <div className="tax-info-panel">
            <div className="info-nav">
                {TAX_INFO.map(info => (
                    <button
                        key={info.id}
                        className={`info-nav-btn ${activeInfo === info.id ? 'active' : ''}`}
                        onClick={() => setActiveInfo(info.id)}
                    >
                        {info.title}
                    </button>
                ))}
            </div>
            
            <div className="info-content">
                {TAX_INFO.map(info => (
                    activeInfo === info.id && (
                        <div key={info.id} className="tax-info">
                            <h3>{info.title}</h3>
                            <p className="info-description">{info.description}</p>
                            
                            <div className="info-details">
                                <h4>Key Facts:</h4>
                                <ul>
                                    {info.details.map((detail, index) => (
                                        <li key={index}>{detail}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
}

export default TaxInfoPanel;
